import { PHONE_DISPLAY, PHONE_TEL } from "../Layout";
import { Link } from "react-router-dom";
import TrustExternalLinks from "../TrustExternalLinks";

/**
 * Dark navy CTA block reused at the bottom of service / city / hub pages.
 * - `title` : main heading.
 * - `subtitle` (optional) : supporting paragraph.
 * - `eyebrow` (optional) : small amber tagline above the title.
 * - `secondaryHref` (optional) : show a secondary "Formulaire de contact" button.
 *
 * The trust-external-links block is rendered just above the CTA so every page
 * using PageFinalCta naturally exposes 3 authoritative outbound links in its
 * main content area (Service-Public, QualiRépar, ADEME).
 */
export default function PageFinalCta({ title, subtitle, eyebrow, secondaryHref }) {
    return (
        <section className="max-w-7xl mx-auto px-5 lg:px-10 pb-20">
            <TrustExternalLinks className="mb-10" />
            <div className="rounded-3xl bg-[var(--navy)] text-[var(--cream)] p-8 lg:p-12 grid lg:grid-cols-2 gap-8 items-center relative overflow-hidden grain">
                <div className="relative">
                    {eyebrow && (
                        <p className="text-xs uppercase tracking-[0.2em] text-[var(--amber)] font-semibold">{eyebrow}</p>
                    )}
                    <h2 className="heading text-2xl lg:text-3xl font-extrabold text-[var(--cream)] mt-3">{title}</h2>
                    {subtitle && (
                        <p className="mt-3 text-[var(--cream)]/80">{subtitle}</p>
                    )}
                </div>
                <div className="relative flex flex-wrap gap-3 lg:justify-end">
                    <a href={PHONE_TEL} className="btn-amber inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full font-bold">
                        <i className="fa-solid fa-phone-volume" /> {PHONE_DISPLAY}
                    </a>
                    {secondaryHref && (
                        <Link
                            to={secondaryHref}
                            className="bg-white text-[var(--navy)] inline-flex items-center gap-2 px-6 py-3.5 rounded-full text-base font-semibold"
                        >
                            Formulaire de contact
                        </Link>
                    )}
                </div>
            </div>
        </section>
    );
}
